import { ReactAPIRegistry } from "./ReactAPIRegistry"

export function getApprovedTags(title: string, languageCode: string): Promise<string[]> {
    return ReactAPIRegistry.get("getApprovedTagsFromTitle")(title, languageCode) as Promise<string[]>
}
